module.exports = __webpack_public_path__ + "img/honor_bg4.cddf78a4.png";